import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchCategory = createAsyncThunk(
  "categories/fetchCategory", 
  async ({ apiResponse }, { rejectWithValue }) => {
    try {
      if (apiResponse && apiResponse.success && Array.isArray(apiResponse.data)) {
        return apiResponse.data;
      }
      
      // Return empty array if no valid input
      console.warn('No valid categories data provided to fetchCategory');
      return [];
    } catch (error) {
      console.error('Error in fetchCategory:', error);
      return rejectWithValue(error.message);
    }
  }
);

const categoriesSlice = createSlice({
    name: "categories",
    initialState: {
        entities: [],
        loading: false,
        error: null,
        selectedCategory: undefined, // Add selectedCategory to the state
        loaded: false, // Track if categories have been loaded
    },
    reducers: {
        setSelectedCategory(state, action) {
            state.selectedCategory = action.payload; // Update the selected category
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.entities = action.payload;
                state.loaded = true; // Mark categories as loaded
            })
            .addCase(fetchCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setSelectedCategory } = categoriesSlice.actions; // Export setSelectedCategory
export default categoriesSlice.reducer;